module.exports = __webpack_public_path__ + "img/follow-Up.3d29a375.png";